import {
  DAILY_REPORT_TYPE,
  FINANCE_REPORT_TYPE,
  MERCHANT_FINANCE_REPORT_TYPE
} from '../../constants/reportTypes';

export default (api) => ({
  // Constants are used in places where we use these namespaces dynamically in the RecipientsList.vue
  [DAILY_REPORT_TYPE]: {
    getRecipients: () => api.get('/reports/daily-performance/recipients'),
    deleteRecipient: (id) => api.delete(`/reports/daily-performance/recipients/${id}`),
    addRecipient: (email) => api.post('/reports/daily-performance/recipients/add', {
      recipient: email
    }),
    triggerReport: () => api.post('/reports/daily-performance/trigger'),
    getIsReportProcessing: () => api.get('/reports/daily-performance/is-report-process'),
  },

  [FINANCE_REPORT_TYPE]: {
    getRecipients: () => api.get('/reports/finance/recipients'),
    deleteRecipient: (id) => api.delete(`/reports/finance/recipients/${id}`),
    addRecipient: (email) => api.post('/reports/finance/recipients/add', {
      recipient: email
    }),
    triggerReport: (data) => api.post('/reports/finance/trigger', data),
  },

  [MERCHANT_FINANCE_REPORT_TYPE]: {
    getRecipients: () => api.get('/reports/merchant-finance/recipients'),
    deleteRecipient: (id) => api.delete(`/reports/merchant-finance/recipients/${id}`),
    addRecipient: (email) => api.post('/reports/merchant-finance/recipients/add', {
      recipient: email
    }),
  },

  accounting: {
    getReports: (params) => api.get('/reports/accounting/get', { params }),
    triggerReport: (data) => api.post('/reports/accounting/trigger', data),
    downloadReport: (reportId) => api.get(`/reports/accounting/download/${reportId}`, {
      responseType: 'blob'
    }),
    getInfo: () => api.get('/reports/accounting/info'),
    getUnlabeledStatements: (merchantId, params) => api.get(`/reports/accounting/statements/${merchantId}/unlabeled`, { params }),
    getLabels: () => api.get('/reports/accounting/statements/labels'),
    /**
     * @param {Array<{id: number, label: string}>} matches - The matches to set the labels for
     */
    setLabels: (matches) => api.put('/reports/accounting/statements/label', { matches }),
    getMerchants: (labeled = false) => api.get('/reports/accounting/statements/merchants', {
      params: {
        labeled
      }
    }),
    getPreviouslyLabeledStatements: (merchantId, params) => api.get(`/reports/accounting/statements/${merchantId}/labeled`, { params }),
  },

  quickbyte: {
    getReports: (params) => api.get('/reports/quickbyte', { params }),
    downloadReport: (reportId, fileId) => api.get(`/reports/quickbyte/${reportId}/download/${fileId}`, {
      responseType: 'blob'
    }),
  }
})
